import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const cadastrarPontoApoio = ({
  cd_ponto_apoio,
  descricao,
  cnpj,
  telefone,
  end_cep,
  end_logradouro,
  end_numero,
  end_complemento,
  end_bairro,
  end_cidade,
  end_uf,
  end_pais,
  end_latitude,
  end_longitude,
  horario_atend_ini,
  horario_atend_fim,
  horario_indisponivel_ini,
  horario_indisponivel_fim,
  capacidade_atend_hora,
  raio_atuacao,
  idc_status,
  min_horas_agendamento,
  idc_agenda_hora,
  dt_inicio_operacao
}) => {
  return axios.post(
    process.env.URL_API_BASE + '/ponto-apoio',
    {
      cd_ponto_apoio,
      descricao,
      cnpj,
      telefone,
      end_cep,
      end_logradouro,
      end_numero,
      end_complemento,
      end_bairro,
      end_cidade,
      end_uf,
      end_pais,
      end_latitude,
      end_longitude,
      horario_atend_ini,
      horario_atend_fim,
      horario_indisponivel_ini,
      horario_indisponivel_fim,
      capacidade_atend_hora,
      raio_atuacao,
      idc_status,
      min_horas_agendamento,
      idc_agenda_hora,
      dt_inicio_operacao
    },
    config
  )
}

const alterarPontoApoio = ({
  id,
  descricao,
  cnpj,
  telefone,
  end_cep,
  end_logradouro,
  end_numero,
  end_complemento,
  end_bairro,
  end_cidade,
  end_uf,
  end_pais,
  end_latitude,
  end_longitude,
  horario_atend_ini,
  horario_atend_fim,
  horario_indisponivel_ini,
  horario_indisponivel_fim,
  capacidade_atend_hora,
  raio_atuacao,
  idc_status,
  min_horas_agendamento,
  idc_agenda_hora,
  dt_inicio_operacao
}) => {
  return axios.patch(
    process.env.URL_API_BASE + '/ponto-apoio/' + id,
    {
      descricao,
      cnpj,
      telefone,
      end_cep,
      end_logradouro,
      end_numero,
      end_complemento,
      end_bairro,
      end_cidade,
      end_uf,
      end_pais,
      end_latitude,
      end_longitude,
      horario_atend_ini,
      horario_atend_fim,
      horario_indisponivel_ini,
      horario_indisponivel_fim,
      capacidade_atend_hora,
      raio_atuacao,
      idc_status,
      min_horas_agendamento,
      idc_agenda_hora,
      dt_inicio_operacao
    },
    config
  )
}

const listarPontoApoio = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/ponto-apoio',
    config
  )
  return response.data
}

const listarPontoApoioAtivos = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/ponto-apoio/listar-ativos/1',
    config
  )
  return response.data
}

const obterPontoApoio = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/ponto-apoio/' + id,
    config
  )
  return response.data
}

const gravarHorario = (data) => {
  return axios.post(
    `${process.env.URL_API_BASE}/ponto-apoio/${data.cd_ponto_apoio}/horario`,
    data,
    config
  )
}

export default {
  cadastrarPontoApoio,
  alterarPontoApoio,
  listarPontoApoio,
  listarPontoApoioAtivos,
  obterPontoApoio,
  gravarHorario
}



// WEBPACK FOOTER //
// ./src/actions/PontoApoioActions.js